import { CompatibilityCheckAnswer, CompatibilityCheckQuestion, MultiSelectionAnswer, SelectAndTextAnswer } from '../../hooks';
import { YesOrNoQuestionPage } from './yesOrNoQuestion';
import { SelectAndTextQuestionPage } from './selectAndTextQuestion';
import { GroupYesOrNoQuestionPage } from './groupYesOrNoQuestion';
import { MultiSelectionQuestionPage } from './multiselectionQuestion';

type QuestionPageProps = {
  question: CompatibilityCheckQuestion;
  initialAnswer: CompatibilityCheckAnswer | null;
  onSubmit: (answer: CompatibilityCheckAnswer) => void;
  backQuestion: () => void;
};

export const QuestionPage = (props: QuestionPageProps) => {
  switch (props.question.kind) {
    case 'yesOrNo':
    case 'yesOrNoAndFile':
      return (
        <YesOrNoQuestionPage
          question={props.question}
          initialAnswer={props.initialAnswer as boolean}
          onSubmit={props.onSubmit}
          backQuestion={props.backQuestion}
        />
      );
    case 'selectAndText':
    case 'selectOnly':
      return (
        <SelectAndTextQuestionPage
          question={props.question}
          initialAnswer={props.initialAnswer as SelectAndTextAnswer}
          onSubmit={props.onSubmit}
          backQuestion={props.backQuestion}
        />
      );
    case 'groupYesOrNo':
      return (
        <GroupYesOrNoQuestionPage
          question={props.question}
          initialAnswer={props.initialAnswer as Array<boolean>}
          onSubmit={props.onSubmit}
          backQuestion={props.backQuestion}
        />
      );
      case 'multiSelection':
        return(
          <MultiSelectionQuestionPage
          question={props.question}
          initialAnswer={props.initialAnswer as MultiSelectionAnswer}
          onSubmit={props.onSubmit}
          backQuestion={props.backQuestion}
        />
        );
  }
};
